import * as React from 'react';
import { Selectors } from '@grandvisionhq/auth';
import { MediaQuery, Logo, Alert, SupportFooter } from '@grandvisionhq/common';
import { SplitPane } from '@grandvisionhq/layout';
import { useIntl, useStore, useSelector } from '@grandvisionhq/state';
import { getSelectedShippingMethod } from '../StepShipping/selectors.js';
import { StepNames } from '../models/shared.js';
import { NavigationContainer } from '../modules/Navigation/NavigationContainer.js';

const CheckoutLayout = ({ showNavigation , logo , status , currentStep , pageRouteRoot , leftContentSection , cartContentSection  })=>{
    const isOverviewStep = currentStep === StepNames.Overview;
    const isShippingStep = currentStep === StepNames.Shipping;
    const { getLabel  } = useIntl();
    const headerRef = React.useRef(null);
    const store = useStore();
    const isLoggedIn = Selectors.isLoggedIn(store.getState());
    const currentBreakpoint = MediaQuery.useBreakpoint();
    const isMobile = currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT || currentBreakpoint === MediaQuery.BreakpointName.PHONE;
    const selectedShippingMethod = useSelector(getSelectedShippingMethod);
    React.useEffect(()=>{
        headerRef.current && headerRef.current.scrollIntoView();
    }, []);
    /**
   *  check status of payment through
   *  url query params
   */ const isFailedCheckoutStep = status === 'failed';
    return /*#__PURE__*/ React.createElement("div", {
        className: "checkout-section"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "checkout-section__header",
        ref: headerRef
    }, logo && /*#__PURE__*/ React.createElement(Logo, {
        className: "checkout-section__logo",
        url: pageRouteRoot,
        image: logo
    }), showNavigation && /*#__PURE__*/ React.createElement(NavigationContainer, {
        currentStep: currentStep,
        isLoggedIn: isLoggedIn
    })), /*#__PURE__*/ React.createElement(SplitPane, {
        main: /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section--main"
        }, isMobile && !isOverviewStep && /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__cart"
        }, cartContentSection), /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__body"
        }, isFailedCheckoutStep && /*#__PURE__*/ React.createElement(Alert, {
            className: "checkout-section__alert",
            type: "warning",
            icon: "warning",
            title: getLabel('checkout.errors.general.title'),
            message: getLabel('checkout.errors.general.message')
        }), !(selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isValid) && (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isTouched) && isShippingStep && /*#__PURE__*/ React.createElement(Alert, {
            className: "checkout-section__alert",
            type: "warning",
            icon: "warning",
            title: getLabel('checkout.warning.invalid.delivery.title'),
            message: getLabel('checkout.warning.invalid.delivery.message')
        }), leftContentSection)),
        aside: /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section--aside"
        }, !isMobile && /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__cart"
        }, cartContentSection ? cartContentSection : null), /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__support-footer"
        }, /*#__PURE__*/ React.createElement(SupportFooter, {
            message: getLabel('support.title'),
            phoneNumber: getLabel('support.phoneNumber', {
                hideLabelKey: true
            }) || undefined,
            email: getLabel('support.emailAddress', {
                hideLabelKey: true
            }) || undefined
        })))
    }));
};

export { CheckoutLayout };
//# sourceMappingURL=CheckoutLayout.js.map
